export default __webpack_public_path__ + "static/media/nft-14.08157d31.png";